













































import { Component, Watch } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import UrlMixin from '@/components/query/url-mixin';
import MainMenuGroupingMixin, { MainMenuLayoutTab } from '@/views/layout/navigation/mixins/main-menu-grouping-mixin';
import { uniq } from 'lodash';
import DimensionsMixin  from '@/components/datatable/dimensions-mixin';
import { DrillFilterOptionsEnum } from '@/services/models/Enums';
import PickersBaseMixin from '@/views/reports/pickers/base';
import query from '@/components/query/query-constructor';

@Component
export default class TreeLevels extends mixins(UrlMixin, PickersBaseMixin, MainMenuGroupingMixin, DimensionsMixin) {
  levels: any[] = ['none', 'none'];

  type: string = '';
  preserveLevels: boolean = false;

  get drills(): string[] {
    return this.$store.state.table.drilldownFilter
      ? this.$store.state.table.drilldownFilter
        .filter((item: Bemob.ReportQueryDrill) => item.filterOptions === DrillFilterOptionsEnum.equals)
        .map((item: Bemob.ReportQueryDrill) => item.filterTables)
      : [];
  }

  get tableDimensions3Values() {
    return this.tableDimensions3.map((item) => item.id);
  }

  get isPickerTree1Hidden() {
    return !this.tableDimensions3Values.includes(this.levels[1]);
  }

  get livesGroup() {
    return ['live-visits', 'live-clicks'];
  }

  get otherGroup() {
    return ['conversions', 'errors'];
  }

  get excludeGroups() {
    return this.livesGroup.concat(this.otherGroup);
  }

  get dimensionKeys() {
    const lives = this.campaignAsFirstTableFilterCondition ? this.livesGroup : []
    const { dimensions } = this.$store.state.reportColumns

    let result =  Object.keys(dimensions)
      .concat(this.otherGroup)

    if(this.$FF?.reportingFlowRulePath?.enabled){
      result = result.concat(['flow_rules','flow_rule_paths'])
    }

    return result.concat(lives);
  }

  get tableDimensions1() {
    return this.dimensionKeys
      .filter((key) => !this.tabsPlainTabsDataExclude.includes(key))
      .map((e) => {
        let text = (this.dimensions as any)[e];
        if(e.indexOf('custom') === 0 ) {
          const customKey = e + 'Name';
          text += this.$store.state.table.customGroups && this.$store.state.table.customGroups[customKey]
            ? ` (${this.$store.state.table.customGroups[customKey]})`
            : '';
        }

        return {
          text: text,
          id: e,
        }
      });
  }

  //multilayer scructure for better change detection handling
  get tableDimensions2Layer1() {
    const result = this.tableDimensions1.filter((e) => !this.excludeGroups.includes(e.id));
    return [{
      text: this.t('None'),
      id: 'none'
    }].concat(result);
  }

  get tableDimensions2Layer2() {
    return this.tableDimensions2Layer1.filter((e) => this.drills.indexOf(e.id) === -1);
  }

  get tableDimensions2() {
    return this.tableDimensions2Layer2.filter((e) => e.id != this.type);
  }

  get tableDimensions3() {
    return this.tableDimensions2.filter((e) => e.id !== this.levels[0]);
  }

  mounted() {
    this.bus.on('preserve-levels', this.onBusPreserveLevels);
    this.bus.on('restore-tree-levels', this.onBusRestoreTreeLevels);
    this.bus.on('splice-level', this.onBusSpliceLevel);
    this.bus.on('apply-filters', this.onBusApplyFilters);
    this.bus.on('report-tab-added', this.onBusReportTabAdded);
    this.bus.on('report-tab-updated', this.onBusReportTabUpdated);
  }

  beforeDestroy() {
    this.bus.off('preserve-levels', this.onBusPreserveLevels);
    this.bus.off('restore-tree-levels', this.onBusRestoreTreeLevels);
    this.bus.off('splice-level', this.onBusSpliceLevel);
    this.bus.off('apply-filters', this.onBusApplyFilters);
    this.bus.off('report-tab-added', this.onBusReportTabAdded);
    this.bus.off('report-tab-updated', this.onBusReportTabUpdated);
  }

  onBusReportTabUpdated() {
    this.levels = this.$store.getters.tableQueryTemporaryForCurrentTab.treeLevels
      ? this.importLevels(this.$store.getters.tableQueryTemporaryForCurrentTab.treeLevels)
      : ['none', 'none'];
  }

  onBusRestoreTreeLevels(tableTreeLevels: string[]) {
    tableTreeLevels = this.importLevels(tableTreeLevels);

    this.type = tableTreeLevels[0];
    if(tableTreeLevels.length) {
      this.levels = this.importLevels(tableTreeLevels.slice(1, 3));
      if(this.levels.length < 2) {
        this.levels = this.levels.concat(new Array(2 - this.levels.length).fill('none'));
      }
      this.preserveLevels = true;
    }
  }

  onBusPreserveLevels() {
    this.preserveLevels = true;
  }

  onBusSpliceLevel(level: string) {
    let levels = this.levels.filter((item: string) => item !== level);
    this.levels = this.levels.map((item: string, index: number) => levels[index] ? levels[index]  : 'none');

    this.saveLevels()
  }

  onBusReportTabAdded() {
    this.type = this.$route.params.type;
    const decodedUrlParams = query.decode(this.$route.params.data)
    if(decodedUrlParams.treeLevels) {
      this.levels = this.importLevels(decodedUrlParams.treeLevels);
    }
    this.levelChanged({isPushUrl:false})
    this.saveLevels()
  }

  onBusApplyFilters() {
    this.saveLevels()
    this.pushURL()
  }

  @Watch('type')
  typeChanged(type: string) {
    if (type && type !== 'undefined' && type !== 'none' && type !== this.$route.params.type) {
      if(this.livesGroup.includes(type)) {
        const tab = this.tabsLayoutFlat[type];

        tab.click();
      } else {
        const tab = this.tabsLayoutFlat[type];
        tab.click();
      }
    }

    this.fixLevelProblems(this.levels);
  }

  fixLevelProblems(levels: string[]) {
    let problem = false;
    for(let i = 0; i < 2; i++) {
      if(!levels[i]) {
        levels[i] = 'none';
        problem = true;
      }
    }

    if(problem) {
      return true;
    }

    const levelsNotAllowed: number[] = levels
      .map((e, index) => this.isHidden(e) || e === this.type ? index : -1)
      .filter((e) => e !== -1);

    if(levelsNotAllowed.length) {
      levelsNotAllowed.forEach((index) => {
        this.levels[index] = 'none';
      });

      if(this.levels[0] === 'none' && this.levels[1] !== 'none') {
        this.levels[0] = this.levels[1];
        this.levels[1] = 'none';
      }

      return true;
    }

    return false;
  }

  get disabled() {
    return this.levels[0] === 'none' || this.levels.length === 0;
  }

  exportLevels(levels: string[]) {
    return levels.map((item: string) => item === 'none'
      ? ''
      : item
    )
  }

  importLevels(levels: string[]) {
    const importLevels = [];
    importLevels[0] = !!levels?.[0] ? levels?.[0] : 'none';
    importLevels[1] = !!levels?.[1] ? levels?.[1] : 'none';
    return importLevels
  }

  levelChanged({ isPushUrl=true }) {
    this.$store.commit('tableSelectedItems', null);

    let tableTreeLevels = this.levels[0]
      ? uniq(this.exportLevels(this.levels))
      : null;

    this.$store.commit('tableTreeLevelsTemporary', tableTreeLevels);
    if(this.$store.getters.tableQueryForCurrentTab.view === 'tree'){
      this.saveLevels()
      if(isPushUrl){
        this.pushURL()
      }
    }
    this.bus.emit('reset-report-tree');
  }

  saveLevels(){
    let tableTreeLevels = this.levels[0]
      ? uniq(this.exportLevels(this.levels))
      : null;

    this.$store.commit('tableTreeLevels',tableTreeLevels);
    this.$store.commit('tableTreeLevelsTemporary', tableTreeLevels);
  }

  @Watch('drills')
  drillsChanged(drills: string[]) {
    this.$nextTick(() => {
      this.typeChanged(this.type);
    });
  }

  @Watch('$route.params.type', {
    immediate: true
  })
  onRouteParamsTypeChanges(val: string) {
    if(this.preserveLevels) {
      this.preserveLevels = false;
    }

    this.type = val;
  }
}
